export enum DeregistrationTypes {
	REZAGO = 1,
	DESUSO = 2,
	DONACION = 3,
	TRANSFERENCIA = 4
}
